import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            {/* Ana Sayfa */}
            <Route path="/" element={<Home />} />
            
            {/* Diğer Sayfalar */}
            <Route path="/hizmetler" element={<Services />} />
            <Route path="/galeri" element={<Gallery />} />
            <Route path="/iletisim" element={<Contact />} />
            
            {/* SEO ve Google Ads için Lokasyon Bazlı URL'ler - Hepsi Ana Sayfayı Gösterir */}
            <Route path="/hamam" element={<Home />} />
            <Route path="/MaltepeMasajSalonu" element={<Home />} />
            <Route path="/MaltepeHamami" element={<Home />} />
            <Route path="/UmraniyeHamami" element={<Home />} />
            <Route path="/UmraniyeMasajSalonu" element={<Home />} />
            <Route path="/UskudarHamami" element={<Home />} />
            <Route path="/UskudarMasajSalonu" element={<Home />} />
            <Route path="/KadikoyHamami" element={<Home />} />
            <Route path="/KadikoyMasajSalonu" element={<Home />} />
            <Route path="/AnadoluyakasiHamami" element={<Home />} />
            <Route path="/AnadoluyakasiMasajSalonu" element={<Home />} />
            <Route path="/AtasehirHamami" element={<Home />} />
            <Route path="/AtasehirMasajSalonu" element={<Home />} />
            <Route path="/BostanciHamami" element={<Home />} />
            <Route path="/BostanciMasajSalonu" element={<Home />} />
            <Route path="/KartalHamami" element={<Home />} />
            <Route path="/KartalMasajSalonu" element={<Home />} />
            <Route path="/BagdatCaddesiHamami" element={<Home />} />
            <Route path="/BagdatCaddesiMasajSalonu" element={<Home />} />
            <Route path="/KucukyaliHamami" element={<Home />} />
            <Route path="/KucukyaliMasajSalonu" element={<Home />} />
            <Route path="/GoztepeHamami" element={<Home />} />
            <Route path="/GoztepeMasajSalonu" element={<Home />} />
            <Route path="/ErenkoyHamami" element={<Home />} />
            <Route path="/ErenkoyMasajSalonu" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
